import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../../base.dto';

export class MedComSenderInformationDto extends BaseDto {
  organisationName: string;
  // Lokationsnummer
  locationIdentifier: string;
}

export class CreateMedComSenderInformationDto
  extends BaseCreateDto
  implements Partial<UpdateMedComSenderInformationDto>
{
  @IsString()
  @IsNotEmpty()
  organisationName: string;

  @IsString()
  @IsNotEmpty()
  locationIdentifier: string;
}

export class UpdateMedComSenderInformationDto
  extends BaseUpdateDto
  implements Partial<UpdateMedComSenderInformationDto>
{
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  organisationName?: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  locationIdentifier: string;
}
